/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { TbCurrencyRupee } from "react-icons/tb";
import GlobalTable from "../../components/global-table";
import { Avatar, Box, Button, Col, Dialog, Divider, Flex, InputField, Row, SelectField, Typography } from "../../ppui";
import { logger } from "../../utils/logger";
import { AllowanceBox,  ContentLayout, ContentTable, HeaderBorder, LeaveBody, LeaveTable, LeaveTableResponsive, LeaveTd, LeaveTh, LeaveThead, LeaveTr } from "../style";
import { headers } from "./loan.data";
import useLoanService from "./use-loan-service";
import { formatToCustomDate, getMonthInStringNotOneIndexBasedNew } from "../../utils/common";

function Index() {

  const {
    fetchAllEmpData,
    empList,
    loanInputs,
    handleChange,
    loanModal,
    handleClickloanModalOpen,
    handleClickloanModalClose,
    handleCLickAddLoan,
    handleSubmit,
    loanListData,
    fetchLoanList,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    fetchEmpLoanDetailsByID,
    empLoanDetails
  } = useLoanService()
  logger.log("loanListData", loanListData)
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    setModalOpen(true);
  }
  const handleCloseModal = () => {
    setModalOpen(false);
  }

  const handleClickEmpName = async (empID, loanID) => {
    await fetchEmpLoanDetailsByID(empID, loanID);
    handleOpenModal(empID, loanID);
  }
  logger.log("empLoanDetails9999", empLoanDetails)

  return (
    <>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={headers}
            rows={loanListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            stickyHeader="true"
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            FetchDataFromRow={(row) => handleClickEmpName(row?.employee_id, row?.loan_id)}

            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                    Loan Management
                </Typography>
              </>
            }
            actionRight={
              <>
               <Button color="primary" variant="contained" onClick={handleCLickAddLoan}>
            Apply Loan
          </Button>
               
              </>
            }
          />
        </ContentTable>
      </ContentLayout>
      {/* Apply Loan Edit Modal */}
      <Dialog
        title="Apply Loan"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={loanModal}
        onClose={handleClickloanModalClose}
        onSubmit={() => handleSubmit()}
      >
        <Row rowGap mb={20}>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              label="Employee Name"
              options={empList}
              placeholder="Select Here..."
              required
              defaultValue={loanInputs?.employee_id}
              valueSinc={!!loanInputs?.employee_id}
              searchable = {true}
              clearable
              labelBold
              onChange={(val) => handleChange(val, 'employee_id')}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Gross Salary"
              placeholder="Gross Salary"
              type="number"
              suffix={<TbCurrencyRupee />}
              required
              value={loanInputs?.gross_salary}
              valueSinc={!!loanInputs?.employee_id}
              onChange={(e) => handleChange(e, 'gross_salary')}
              disabled

            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Loan Amount"
              placeholder="Loan Amount"
              type="text"
              suffix={<TbCurrencyRupee />}
              required
              value={loanInputs?.loan_amount}
              valueSinc={!!loanInputs.loan_amount}
              onChange={(e) => handleChange(e.target.value, 'loan_amount')}
            />
          </Col>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              label="Deduction Type"
              options={[
                { id: "fixed", name: "Fixed" },
                { id: "flexible", name: "Flexible" },
              ]}
              placeholder="Select Here..."
              required
              defaultValue="fixed"
              valueSinc={!!loanInputs?.deduction_type}
              onChange={(val) => handleChange(val, 'deduction_type')}
              disabled={true}
            />

          </Col>
          <Col sm={12} md={6}>
            {/* {loanInputs?.deduction_type === "fixed" &&
              <SelectField
                fullWidth
                label="Tenure In Months"
                options={[
                  { id: "3", name: "3 Months" },
                  { id: "6", name: "6 Months" },
                  { id: "9", name: "9 Months" },
                  { id: "12", name: "12 Months" },
                  { id: "18", name: "18 Months" },
                  { id: "24", name: "24 Months" },
                  { id: "36", name: "36 Months" },
                  { id: "48", name: "48 Months" },
                  { id: "60", name: "60 Months" },
                ]}
                placeholder="Select Here..."
                required
                defaultValue={loanInputs?.tenure}
                valueSinc={!!loanInputs?.tenure}
                onChange={(val) => handleChange(val, 'tenure')}
                disabled={loanInputs?.deduction_type === "flexible" ? true : false}
              />
            } */}
            {/* {loanInputs?.deduction_type === "flexible" && */}
            <InputField
              fullWidth
              label="Tenure In Months"
              placeholder="Tenure In Months"
              type="text"
              suffix={<TbCurrencyRupee />}
              required
              value={loanInputs?.tenure}
              valueSinc={!!loanInputs.tenure}
              onChange={(e) => handleChange(e.target.value, 'tenure')}
            />
            {/* } */}
          </Col>
          <Col sm={12} md={6}>
            <InputField
              fullWidth
              label="Monthly Deduction"
              placeholder="Monthly Deduction"
              type="number"
              suffix={<TbCurrencyRupee />}
              required
              value={loanInputs?.monthly_deduction}
              valueSinc={!!loanInputs?.monthly_deduction}
              onChange={(e) => handleChange(e.target.value, 'monthly_deduction')}
              disabled={loanInputs?.deduction_type === "fixed" ? true : false}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              type="date"
              fullWidth
              placeholder="Type here..."
              label="Loan Issue Date"
              required
              valueSinc
              value={loanInputs?.loan_issue_date}
              onChange={(e) => handleChange(e.target.value, 'loan_issue_date')}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputField
              type="date"
              fullWidth
              placeholder="Type here..."
              label="Loan Deduction Date"
              required
              valueSinc
              value={loanInputs?.loan_deduction_date}
              onChange={(e) => handleChange(e.target.value, 'loan_deduction_date')}
            />
          </Col>

        </Row>
      </Dialog>
      <Dialog
        title="Loan Details"
        closeButton={true}
        action={false}
        fullWidth
        separator
        maxWidth="lg"
        bodyScroll={true}
        open={modalOpen}
        onClose={handleCloseModal}

      >
        <Row alignItem="center">
          <Col sm={12}>
            <Row alignItem="center">
              <Col sm={"auto"}>
                <Avatar
                  size="md"
                  color="primary"
                  initials={`${empLoanDetails?.loan_history?.[0].employee_name
                      ?.trim()
                      .split(' ')
                      .map(word => word[0])
                      .slice(0, 2)
                      .join('')
                      .toUpperCase()
                    }`}
                // src={leaveInfo?.employee_image}
                />
              </Col>
              <Col sm={4}>
                <HeaderBorder>
                  <Typography variant="h6" mb={"0"}>
                    {empLoanDetails?.loan_history?.[0].employee_name}
                  </Typography>
                  <Typography variant="body2">
                    {empLoanDetails?.employee_id}
                  </Typography>
                </HeaderBorder>
              </Col>
              <Col sm={2}>
                <HeaderBorder>
                  <Typography variant="body1" mb={"0"}>
                    Gross Salary
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {empLoanDetails?.gross_salary}
                  </Typography>
                </HeaderBorder>
              </Col>
              <Col sm={2}>
                <HeaderBorder>
                  <Typography variant="body1" mb={"0"}>
                    Loan Amount
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {empLoanDetails?.loan_amount}
                  </Typography>
                </HeaderBorder>
              </Col>
              <Col sm={2}>
                <Typography variant="body1" mb={"0"}>
                  Due Amount
                </Typography>
                <Typography variant="body2" mb={"0"}>
                  {(empLoanDetails?.loan_amount -
                    (empLoanDetails?.loan_history?.reduce((total, history) => total + (history?.loan_advance || 0), 0) || 0)
                  ).toFixed(0)}
                </Typography>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider gap={20} />
        <Flex gap={20} direction={"column"}>
          <AllowanceBox>
            <Row alignItems="center">
              <Col>
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  gap={{ md: 20, lg: 40, xxl: 60 }}
                >
                  <Box>
                    <Box className="label">Loan Id</Box>
                    <Box className="value">{empLoanDetails?.loan_id}</Box>
                  </Box>

                  <Box>
                    <Box className="label">Deduction Type</Box>
                    <Box className="value">{empLoanDetails?.deduction_type}</Box>
                  </Box>

                  <Box>
                    <Box className="label">Tenure</Box>
                    <Box className="value">{empLoanDetails?.tenure}</Box>
                  </Box>
                  <Box>
                    <Box className="label">Monthly deduction</Box>
                    <Box className="value">{empLoanDetails?.monthly_deduction}</Box>
                  </Box>
                  <Box>
                    <Box className="label">Loan Issue Date</Box>
                    <Box className="value">{formatToCustomDate(new Date(empLoanDetails?.loan_issue_date))}</Box>
                  </Box>
                  <Box>
                    <Box className="label">Loan Deduction Date</Box>
                    <Box className="value">{formatToCustomDate(new Date(empLoanDetails?.loan_deduction_date))}</Box>
                  </Box>
                </Flex>
              </Col>
            </Row>
          </AllowanceBox>
        </Flex>
        <Divider gap={20} />
        <LeaveTableResponsive>
          <Typography mb={"10"} variant="h6" strong>Loan History</Typography>
          <LeaveTable>
            <LeaveThead>
              <LeaveTr>
                <LeaveTh>
                  <Typography m={"0"} variant="body2" strong>
                    Year
                  </Typography>
                </LeaveTh>
                <LeaveTh>
                  <Typography m={"0"} variant="body2" strong>
                    Month
                  </Typography>
                </LeaveTh>
                <LeaveTh>
                  <Typography m={"0"} variant="body2" strong align="right">
                    Loan EMI
                  </Typography>
                </LeaveTh>
                {/* <LeaveTh>
                  <Typography m={"0"} variant="body2" strong align="right">
                    Loan Due Amount
                  </Typography>
                </LeaveTh> */}
              </LeaveTr>
            </LeaveThead>
            <LeaveBody>
              {(empLoanDetails?.loan_history && empLoanDetails?.loan_history?.length > 0) ? (
                empLoanDetails?.loan_history.map((history, index) => (
                  <LeaveTr key={index}>
                    <LeaveTd>
                      <Typography m={"0"} variant="body2">{history?.year}</Typography>
                    </LeaveTd>
                    <LeaveTd>
                      <Typography m={"0"} variant="body2">{getMonthInStringNotOneIndexBasedNew(history?.month)}</Typography>
                    </LeaveTd>
                    <LeaveTd>
                      <Typography m={"0"} variant="body2" align="right">{history?.loan_advance}</Typography>
                    </LeaveTd>
                    {/* <LeaveTd>
                      <Typography m={"0"} variant="body2" align="right">
                        {(empLoanDetails?.loan_amount -
                          (empLoanDetails?.loan_history?.reduce((total, history) => total + (history?.loan_advance || 0), 0) || 0)
                        ).toFixed(2)}
                      </Typography>
                    </LeaveTd> */}
                  </LeaveTr>
                ))
              ) : (
                'N/A'
              )}
            </LeaveBody>
          </LeaveTable>
        </LeaveTableResponsive>
      </Dialog>
    </>
  );
}

export default Index;
